
import { CENIK } from "./ceny";


// AUTO: kompatibilita (drive byl dřív ceny.jsx)
const CENIK_LIST = Array.isArray(CENIK) ? CENIK : Object.values(CENIK || {});

export const CENIK_MAP = Object.fromEntries(
  (CENIK_LIST || []).map((item) => [item.id, item])
);

export function getCenikItem(id) {
  return CENIK_MAP[id] || null;
}
